import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider.jsx';
import SpeakerRow from './SpeakerRow.jsx';
import Loader from '../../assets/tools/Loder/loader';

const Speakers = () => {
  const [speakers, setspeakers] = useState([]);
  const [conferenceId , setConferenceId] = useState(DEFAULT_CONFERENCE_ID) ; 
  const { SetNotification } = useStateContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => { 
    const controller = new AbortController () ; 
    const signal = controller.signal ; 

    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await AxiosClient.get(`/conference/${conferenceId}/speakers`);
        setspeakers(response.data);
        setLoading(false);
      } catch (error) {

        if (error.name === 'CanceledError') {
          console.log('Request aborted');
          return; // Ignore the error if the request was aborted
        }

        console.error(error);
        SetNotification('Error fetching data', 'danger');
      }
    };
    fetchData(); 

    return () => {
      controller.abort(); // Abort the previous request when conferenceId changes
    };

  }, [conferenceId]);

  const handleDeletespeaker = async (id) => {
    try {
    await AxiosClient.delete(`/speakers/${id}`);
      setspeakers(speakers.filter(speaker => speaker.id !== id));
      SetNotification('A speaker has been deleted', 'success');
    } catch (error) {
      console.error(error);
      SetNotification('Error while deleting the speaker', 'danger');
    }
  };

  return (
    <section className="p-4">
      {conferenceId && (
        <>
          <div className="card border-0 shadow-sm rounded-4 p-3 mb-4 dashboard-actions">
            <Link className="btn btn-dark" to={`./Add/${conferenceId}`}>
              <i className="material-icons me-2">add_box</i> Add speaker
            </Link>
            <Link className="btn btn-outline-warning" to={`./sort/${conferenceId}`}>
              <i className="material-icons me-2">sort</i> Edit sort order
            </Link>
          </div>

          <div className="card border-0 shadow-sm rounded-4 p-0 overflow-hidden">
            <div className="table-responsive">
              {loading ? (
                <div className="p-4">
                  <Loader label="Loading speakers..." />
                </div>
              ) : speakers && speakers.length > 0 ? (
                <table className="table align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="ps-4">Name</th>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Image</th>
                      <th className="pe-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {speakers.map((speaker) => (
                      <SpeakerRow
                        key={speaker.id}
                        name={speaker.name}
                        title={speaker.title}
                        description={speaker.description}
                        image={speaker.image}
                        id={speaker.id}
                        onDelete={handleDeletespeaker}
                      />
                    ))}
                  </tbody>
                </table>
              ) : (
                <div className="p-4 text-center text-muted">No speakers found for this conference.</div>
              )}
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default Speakers;
